// extracted by mini-css-extract-plugin
module.exports = {"Scrollbar":"Scrollbar_Scrollbar__2Nsf-"};